import { PlacementDetailsTableService, PlacementUtils } from '../';
import axios from "axios";
import { Constants, CookieService, Utils, MediaOpsService, authansid } from "../../../shared";

export const CreatePlacementOrPackageService = {

    // todo: check about this values with Krishna: primaryPlacement, marketValue, provider
    // creates payload for placement creation
    prepareCreatePlacementPayload: (formData, omniProfile, packageType="Standalone",programmaticParentId, selectedItems, taxonomyFields = null) => {
        const payload = [{
            "packageType": packageType,
            "placementCost": {
                "unitAmount": (formData['Unit Amount'] || formData['Unit Amount'] === 0) ? formData['Unit Amount'] : 0,
                "plannedCost": {
                    "amount": (formData['Planned Cost'] || formData['Planned Cost'] === 0) ? Number(formData['Planned Cost']) : 0
                },
                "rate": {
                    "amount": (formData['Rate'] || formData['Rate'] === 0) ? Number(formData['Rate']) : 0
                }
            },
            "placementNumber": null,
            "placementTaxonomy": formData['Placement Name'],
            "placementTaxonomyDisplay": formData['Placement Display Name'],
            "overridenPlacementTaxonomy" : formData['Override Placement Name'],
            "overridenPlacementTaxonomyDisplay" : formData['Override Placement Display Name'] ,
            "taxonomySchema":  formData['Placement Schema'],
            "placementType": !formData['Parameter Code Buy Type']||formData['Parameter Code Buy Type'] == 'NU'? '':formData['Parameter Code Buy Type'],
            "buyCategory": formData['Parameter Code Buy Category'],
            "unitType": formData['Parameter Code Unit Type'],
            "costMethod": formData['costMethod'],
            "site": !formData['Parameter Code Site']||formData['Parameter Code Site'] == 'NU'? '':formData['Parameter Code Site'],
            "supplierCode": formData['supplierCode'],
            "supplier": formData['supplier'] || formData['Parameter Code Supplier'],
            "dimensionsPosition": formData['Parameter Code Dimension/Positions'],
            "dimensions": formData['Parameter Code Dimensions'],
            "flightStart": PlacementDetailsTableService.converDateToYMDFormat(formData['Flight Start']),
            "flightEnd": PlacementDetailsTableService.converDateToYMDFormat(formData['Flight End']),
            // remove served by dropdown for package's
            "servedBy": formData['Parameter Code Served By'],
            "createdBy": omniProfile?.email,
            "data_source": '',
            "primaryPlacement": false,
            "marketValue": "",
            "provider": !formData['Parameter Code Site']||formData['Parameter Code Site'] == 'NU'? '':formData['Parameter Code Site'],
            "overrideTaxonomy" : formData["isOverride"],
            "parameterCode": formData["Parameter Code"],
            "parameterCodeTaxonomyDisplay":formData["Parameter Code Display Name"],
            "parameterCodeTaxonomySchema":formData["Parameter Code Schema"],
            "parentId" : programmaticParentId,
            "ad_verification": formData['Parameter Code Ad Verification'],
            "ad_server": formData['Parameter Code Ad Server'],
            "is_ad_server_fee_override": formData['overrideAdservingFees'],
            "is_ad_verification_fee_override": formData['overrideAdverificationFees'],
            "cpcCalcType": formData['CPC Calculation Type'],
            "billable": formData['billable'] ? formData['billable'] : null,
            "billableRate": formData['billableRate'] ? formData['billableRate'] : null,
            "margin": formData['margin'] ? formData['margin'] : null,
            "marginPercentage": formData['markupPercent'] ? formData['markupPercent'] : null,
            "tierId": formData['TierId'] ? formData['TierId'] : null,
            "taxonomy": formData['taxonomy'] ? formData['taxonomy'] : null,
            'taxonomy_client_id': formData.taxonomy_client_id,
            'taxonomy_schema_id': formData.taxonomy_schema_id
        }];

        // if adserving fee checkbox is not selected then the fee will be null 
        // and if selected with proper value the value is assigned
        // and if selected with no value entered then fee will be null
        if (!formData['overrideAdservingFees']) {
            payload[0]['ad_server_fee'] = null;
        } else if (formData['overrideAdservingFees']) {
            if (Number(formData['adserverfee'])) {
                payload[0]['ad_server_fee'] = Number(formData['adserverfee']);
            } else {
                payload[0]['ad_server_fee'] = null;
            }
        }

        // if adverification fee checkbox is not selected then the fee will be null 
        // and if selected with proper value the value is assigned
        // and if selected with no value entered then fee will be null
        if (!formData['overrideAdverificationFees']) {
            payload[0]['ad_verification_fee'] = null;
        } else if (formData['overrideAdverificationFees']) {
            if (Number(formData['adverificationfee'])) {
                payload[0]['ad_verification_fee'] = Number(formData['adverificationfee']);
            } else {
                payload[0]['ad_verification_fee'] = null;
            }
        }

        if(selectedItems?.length){
            const packageCount = selectedItems.filter((pkg) => pkg.package_type === "Package").length;
            const childCount = selectedItems.filter((pkg) => pkg.package_type === "Child").length;
            const standaloneCount = selectedItems.filter((pkg) => pkg.package_type === "Standalone").length;

            if (packageCount === 1 && childCount >= 0 && (childCount+packageCount === selectedItems.length) && packageType !== "DirectCreative") {
                payload[0].parentId = selectedItems[0]?.id;
                payload[0].packageType = "Child";
            }

            if (packageType === "DirectCreative" && childCount === 1) {
                payload[0].parentId = selectedItems.find((pkg) => pkg.package_type === "Child")?.id;
            }

            if (packageType === "DirectCreative" && standaloneCount === 1 && packageCount === 0 && childCount === 0) {
                payload[0].parentId = selectedItems.find((pkg) => pkg.package_type === "Standalone")?.id;
            }

        }

       //Remove because there Taxonomy value placeholder going in small letter case
        // if (taxonomyFields && taxonomyFields?.taxonomyTextcase) {
            // Apply transformation to the main payload
            // CreatePlacementOrPackageService.applyTextCaseTransformation(payload[0], taxonomyFields);
        // }

        return payload;        
    },

    /**
     * Recursively applies text case transformation to placement and all nested childLineItems
     * @param {Object} placementPayload - The placement payload object
     * @param {Object} taxonomyFields - The taxonomy fields containing text case settings
     */
    applyTextCaseTransformation: (placementPayload, taxonomyFields) => {
        if (!taxonomyFields?.taxonomyTextcase) return;

        // Apply transformation to the current placement
        if (placementPayload.placementTaxonomy) {
            placementPayload.placementTaxonomy = PlacementUtils.transformValueToGivenCase(
                placementPayload.placementTaxonomy, 
                taxonomyFields.taxonomyTextcase
            );
        }
        
        if (placementPayload.placementTaxonomyDisplay) {
            placementPayload.placementTaxonomyDisplay = PlacementUtils.transformValueToGivenCase(
                placementPayload.placementTaxonomyDisplay, 
                taxonomyFields.taxonomyTextcase
            );
        }
        
        // Apply transformation to override fields if they exist
        if (placementPayload.overridenPlacementTaxonomy) {
            placementPayload.overridenPlacementTaxonomy = PlacementUtils.transformValueToGivenCase(
                placementPayload.overridenPlacementTaxonomy, 
                taxonomyFields.taxonomyTextcase
            );
        }
        
        if (placementPayload.overridenPlacementTaxonomyDisplay) {
            placementPayload.overridenPlacementTaxonomyDisplay = PlacementUtils.transformValueToGivenCase(
                placementPayload.overridenPlacementTaxonomyDisplay, 
                taxonomyFields.taxonomyTextcase
            );
        }

        // Recursively apply transformation to all nested childLineItems
        if (placementPayload.childLineItems && Array.isArray(placementPayload.childLineItems)) {
            placementPayload.childLineItems.forEach(childItem => {
                CreatePlacementOrPackageService.applyTextCaseTransformation(childItem, taxonomyFields);
            });
        }
    },

    /**
     * Validates form data for free text fields that don't allow spaces
     * @param {Object} formData - The form data to validate
     * @param {Array} taxonomyFields - The taxonomy fields configuration
     * @returns {Object} - Validation result with isValid and errors
     */
    validateFormData: (formData, taxonomyFields) => {
        const errors = {};
        let isValid = true;
        
        // Check taxonomy schema fields
        if (formData['Placement Schema'] && taxonomyFields) {
            const schemaFields = formData['Placement Schema'].split('|');
            
            schemaFields.forEach(fieldName => {
                const fieldConfig = taxonomyFields.find(field => field.name === fieldName);
                const value = formData[fieldName];
                
                if (fieldConfig && fieldConfig.field_type !== 1) { // Not a dropdown field
                    const validation = PlacementDetailsTableService.validateFreeText(value, fieldConfig);
                    if (!validation.isValid) {
                        errors[fieldName] = validation.message;
                        isValid = false;
                    }
                }
            });
        }
        
        // Check parameter code fields if needed
        
        return { isValid, errors };
    },

    /**
     * prepare payload for child and parent for inline edit
     * @param {object} placement 
     * @param {object} state 
     * @returns placement payload object
     */
    preparePayloadForPlacmentsUpdate:(placement,state) => {
        let schemaPayload = CreatePlacementOrPackageService.assignPayloadValues(placement,state);
        let childPayload = []
        if(state?.childPlacmentsArray.length){
            state.childPlacmentsArray.forEach(item=>{
                let payload = CreatePlacementOrPackageService.assignPayloadValues(item,state);
                childPayload.push(payload);
            });
            schemaPayload = {
                childLineItems:[...childPayload],
                ...schemaPayload
            }
        }
        return schemaPayload;
    },

    /**
     * create payload object for inline edit ,assign value to keys
     * @param {object} placement 
     * @param {object} state 
     * @returns payload with object
     */
    assignPayloadValues: (placement,state) => {
        let payload = {
            "placementType": placement.placement_type,
            "buyCategory": placement.buy_category,
            "dimensions": placement.dimensions,
            "dimensionsPosition": placement?.dimension_positions || placement.dimensions_position,
            "servedBy": placement.served_by,
            "unitType": placement.unit_type,
            "costMethod": placement.cost_method,
            "site": placement.site,
            "provider": placement.provider,
            "id": placement.id
        }

        return {
            "is_currency_local": state.systemParametersData.data.isCurrencyLocal,
            "campaign_netmedia": state.campaignObj?.campaign_total_budget,
            "campaign_netmedia_local": state.campaignObj?.campaign_total_budget_local,
            "clientId": Utils.getRouteParam("clientid"),
            "placementTaxonomy": placement["placement_taxonomy"],
            "placementTaxonomyDisplay": placement["placement_taxonomy_display"],
            "overridenPlacementTaxonomy": placement["overriden_placement_taxonomy"] ? placement["overriden_placement_taxonomy"] : null,
            "overridenPlacementDisplayTaxonomy": placement["overriden_placement_display_taxonomy"] ? placement["overriden_placement_display_taxonomy"] : null,
            "taxonomySchema": placement["taxonomy_schema"],
            "parameterCode": placement["parameter_code"],
            "parameterCodeTaxonomyDisplay": placement["parameter_code_taxonomy_display"],
            "parameterCodeTaxonomySchema": placement["parameter_code_taxonomy_schema"],
            "placementType":placement['placement_type'],
            "taxonomy":placement['taxonomy'],
            "updated_by": state?.omniProfile && state.omniProfile['email'],
            'taxonomy_client_id': placement.taxonomy_client_id,
            'taxonomy_schema_id': placement.taxonomy_schema_id,
            ...payload,
        }
    },

    // API call for package/placement creation
    createPlacementOrPackage: (campaignId, payload, versionOneApi) => {
        
        const url = versionOneApi === "V1"
        ? `${Constants.CampaignDataUrl}/${campaignId}/placements` 
        : `${Constants.CampaignDataUrlV2}/${campaignId}/placements`;

        return axios
            .post(url,
                payload,
                {
                    headers: {
                        ansid: authansid,
                        clientid: Utils.getRouteParam("clientid")
                    }
                })
            .then((response) => {
                return response;
            })
    },

    // API call for package/placement update
    updatePlacementOrPackage: (campaignId, placementId, payload, versionOneApi) => {
        const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
        return axios.put(url + '/' + campaignId + '/placements/' + placementId,payload,{
            headers: {
                ansid: CookieService.getCookie("ANsid"),
                clientid: Utils.getRouteParam("clientid")
            }
        })
        .then((response) => {
            return response;
        })
    },
    
    // API call for placement update
    updatePlacements: (campaignId, payload, versionOneApi) => {
        const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
        return axios.put(url + '/' + campaignId + '/placements?parameter-update=true',payload,{
            headers: {
                ansid: CookieService.getCookie("ANsid"),
                clientid: Utils.getRouteParam("clientid")
            }
        })
        .then((response) => {
            return response;
        })
    },

    // creates payload for create package
    prepareCreatePackagePayload: (formData, omniProfile, selectedPlacements, packageType = "Package", taxonomyFields = null) => {
        return new Promise(function (resolve, reject) {
            const packageData = CreatePlacementOrPackageService.prepareCreatePlacementPayload(
                formData, 
                omniProfile, 
                packageType, 
                null, 
                selectedPlacements,
                taxonomyFields
            );
            delete packageData[0]['servedBy'];
            packageData[0]['exportStatus'] = "Not Exported";
            packageData[0]['childLineItems'] = [];
            packageData[0]['packageType'] = packageType;
            
            if(selectedPlacements.length > 0){
                selectedPlacements.forEach((placement, placementindex) => {
                    packageData[0]['childLineItems'].push(CreatePlacementOrPackageService.createSelectedPlacementAsChildLineItems(placement));
                    if (placementindex === selectedPlacements.length - 1) {
                        resolve(packageData);
                    }
                });
            } else { 
                resolve(packageData);
            }
        });
    },

    // creates childlineitems for package payload
    createSelectedPlacementAsChildLineItems: (placement) => {
        return {
            "id": placement.id,
            "packageType": "Child" //hardcode
        }
    },
    
    /**
     * Create parameter equaly for programatic palcement and line item and creative
     * @param {Object} parentPayload 
     * @param {Array} ChildrenPayload 
     * @returns neated array payaload of children line items creative
     */
    assignParameterValueToChildPlacement: (parentPayload,ChildrenPayload,defaultTaxonomyData, taxonomyFields = null) => {
        let childItemsPayload = [];
        ChildrenPayload.forEach(val=>{
            let payload = val;
            if(!val['isDelete'] && !val['creative_id']){
                // get override fees checkbox values from parent and assign it to children
                if (parentPayload?.is_ad_server_fee_override) {
                    val['is_ad_server_fee_override'] = true;
                }
                if (parentPayload?.is_ad_verification_fee_override) {
                    val['is_ad_verification_fee_override'] = true;
                }
                //Useing defultTaxonomy to fill all parameter value dynamically
                //regx are use to create payload key value (remove extra space and symble ex: Dimension/Positions => dimensionPositions)
                defaultTaxonomyData?.fields.forEach(val=>{
                    let name = val.name.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
                        return index === 0 ? word.toLowerCase() : word.toUpperCase();
                    }).replace(/\s+/g, '');
                    name = name.replace(/[^A-Z0-9]+/ig, "");
                    payload = CreatePlacementOrPackageService.assignParameterValueToChildPlacementUpdatePayload(payload, parentPayload, name);
                });
                

                if(payload['childLineItems'] && payload.childLineItems.length){
                    payload['childLineItems'] = CreatePlacementOrPackageService.assignParameterValueToChildPlacement(parentPayload,val.childLineItems,defaultTaxonomyData, taxonomyFields)
                }
            }
            let taxonomy = payload['taxonomy']?.map((item) => {
                delete item['field_name'];
                delete item['name'];
                delete item['hidden'];
                return item;
            });
            payload['taxonomy'] = taxonomy;
            childItemsPayload.push(payload);
        });
        return childItemsPayload;
    },

    // updating the children placement payload from parent
    assignParameterValueToChildPlacementUpdatePayload: (payload, parentPayload, name) => {
        payload["parameterCode"]= parentPayload["parameterCode"];
        payload["parameterCodeTaxonomyDisplay"] = parentPayload["parameterCodeTaxonomyDisplay"];
        payload["parameterCodeTaxonomySchema"] = parentPayload["parameterCodeTaxonomySchema"];
        if(payload.name === 'Buy Type'){
            payload["placementType"] = parentPayload['placementType']; 
        }else if(payload.name === 'Site'){
            payload["provider"] = parentPayload[name];
            payload[name] = parentPayload[name];
        }else if(payload.name === 'Ad Verification'){
            payload['ad_verification'] = parentPayload['ad_verification'];
        }else if(payload.name === 'Ad Server'){
            payload['ad_server'] = parentPayload['ad_server'];
        }else if(payload.name === 'Dimension/Positions'){
            payload['dimensionsPosition'] = parentPayload['dimensionsPosition'];
        }else{
            payload[name] = parentPayload[name];
        }
        return payload;
    },

    /**
     * Retrieves the package type based on the programmatic type.
     * @returns {string} The corresponding package type.
     */
    getPackageType : (programmaticType) => {
        switch (programmaticType) {
            case 'Placement':
                return "ProgrammaticPlacement";
            case 'Line Item':
            case 'Social Line Item':    
                return "DSP";
            case 'Creative Placement':
                return "Child";
            default:
                break;
        }
    },
   
   /**
     * Retrieves the programmatic type based on the package type .
     * @returns {string} The corresponding package type.
     */
    getProgrammaticType : (programmaticType,socialProgrammaticFlag) => {
        if(programmaticType === 'ProgrammaticPlacement'){
            return 'Placement'
        } else if (socialProgrammaticFlag && programmaticType === 'DSP') {
            return "Social Line Item"
        } else if (programmaticType === 'DSP' ) {
            return "Line Item"
        } else if (programmaticType === 'Child') {
            return "Creative Placement"
        }
    },

    createPackageChildItemsPayload: (placementList, omniProfile, isEdit, taxonomyFields = null) => {
        let placementChildPayloads = []
        if(placementList && placementList.length){
            placementList.forEach((items)=>{
                let payload = CreatePlacementOrPackageService.prepareCreatePlacementPayload(
                    items, 
                    omniProfile, 
                    'Standalone', 
                    null, 
                    [], 
                    taxonomyFields
                )[0];
                delete payload['servedBy'];
                payload['exportStatus'] = "Not Exported";
                let id = Number(items.id);
                if(isEdit && id){
                    payload['id'] =  id;
                }
                if(items?.nestedData?.length){
                    payload['childLineItems'] = CreatePlacementOrPackageService.createPackageChildItemsPayload(items.nestedData, omniProfile, isEdit, taxonomyFields);
                } else {
                    payload['childLineItems'] = [];
                }
                payload['packageType'] = CreatePlacementOrPackageService.getPackageType(items.programmaticType);
                payload['creative_id'] = items.creative_id;
                placementChildPayloads.push(payload);
            });
        }
        return placementChildPayloads;
    },

    /**
     * Create form data for planit package to intantiate the package during child creation
     * @param {Object} planitData - planit package data
     * @param {Object} childData - child placement data to be created
     * @returns {Object} - form data for planit package
    */ 
    createFormDataForPlanItPackage: (planitData, childData) => {
        return {
            'isOverride' : true,
            'packageType' : childData.packageType === 'Child' ? 'Package' : 'Standalone',
            'Placement Name': planitData.placement_taxonomy,
            'Placement Display Name': planitData.placement_taxonomy_display,
            'Override Placement Name': planitData.placement_taxonomy,
            'Override Placement Display Name': planitData.placement_taxonomy_display,
            'Placement Schema': planitData.taxonomy_schema,
            'Parameter Code Buy Type': childData.placement_type,
            'Parameter Code': childData.parameterCode,
            'Parameter Code Display Name': childData.parameterCodeTaxonomyDisplay,
            'Parameter Code Schema': childData.parameterCodeTaxonomySchema,
            'TierId': planitData.tier_id,
            'Flight Start': Utils.formatDateObject(planitData.flight_start.split(" ")[0]),
            'Flight End': Utils.formatDateObject(planitData.flight_end.split(" ")[0]),
            'Unit Amount': planitData.unit_amount,
            'Rate': planitData.rate,
            'Planned Cost': planitData.planned_cost,
            'Parameter Code Unit Type': planitData.unit_type,
            'Parameter Code Site': childData.site
        };
    },

    /**
     * Converts the keys of an object by removing underscores and making all characters lowercase.
     *
     * @param {Object} obj - The input object with keys to be converted.
     * @returns {Object} - A new object with converted keys.
     */
    convertObjectKeys: (obj) => {
        const newObj = {};
        Object.keys(obj).forEach(key => {
            const newKey = key.replace(/_/g, '').toLowerCase();
            newObj[newKey] = obj[key];
        });
        return newObj;
    },

    /**
     * Cleans a string by removing underscores, slashes, and spaces, and converts it to lowercase.
     *
     * @param {string} str - The input string to be cleaned and converted.
     * @returns {string} - The cleaned and converted string.
     */
    cleanAndConvertString: (str) => {
        return str.replace(/[_\/\s]/g, '').toLowerCase();
    },

    /**
     * Updates the PDMS data in placement taxonomy fields.
     *
     * This method processes the placement data if the data source is 'planit'. It converts the keys of the placement data
     * to remove underscores and make them lowercase. It then iterates over the schema array to update the DefaultData
     * object with the corresponding field values from the placement data.
     *
     * @param {Array<string>} schemaArr - The array of schema fields to be updated.
     * @param {Object} DefaultData - The object containing the default data to be updated.
     * @param {Object} placementData - The object containing the placement data.
     * @param {Array<Object>} fields - The array of field objects containing field details.
     */
    updatePdmsDataInPlacementTaxonomyFields(schemaArr, DefaultData, placementData, fields) {
        if (placementData?.data_source === 'planit') {
            const updatePlacementData = CreatePlacementOrPackageService.convertObjectKeys(placementData);
            schemaArr.forEach((field) => {
                let updatedFieldValue = updatePlacementData[CreatePlacementOrPackageService.cleanAndConvertString(field)];
                updatedFieldValue = updatedFieldValue?.toLowerCase();
                if (updatedFieldValue) {
                    fields.forEach((tfield) => {
                        if (tfield.name === field) {
                            if (tfield?.field_type === 1) {
                                tfield.fielditems.forEach((fieldOption) => {
                                    if (CreatePlacementOrPackageService.cleanAndConvertString(fieldOption.name) === updatedFieldValue) {
                                        DefaultData[field] = fieldOption.code;
                                    }
                                });
                            } else {
                                DefaultData[field] = updatePlacementData[CreatePlacementOrPackageService.cleanAndConvertString(field)]
                            }
                        }
                    });
                }
            });
        }
    },

    /**
     * Updates the PDMS data in parameter code taxonomy fields.
     *
     * This method processes the placement data if the data source is 'planit'. It converts the keys of the placement data
     * to remove underscores and make them lowercase. It then iterates over the parameter schema to update the DefaultData
     * object with the corresponding field values from the placement data.
     *
     * @param {Object} DefaultData - The object containing the default data to be updated.
     * @param {Object} placementData - The object containing the placement data.
     * @param {Array<Object>} fields - The array of field objects containing field details.
     */
    updatePdmsDataInParameterCodeTaxonomyFields(DefaultData, placementData, fields) {
        if (placementData?.data_source === 'planit') {
            const updatePlacementData = CreatePlacementOrPackageService.convertObjectKeys(placementData);
            const parameterSchema = fields.map(item => item.name)
            parameterSchema.forEach((field) => {
                let updatedFieldValue = updatePlacementData[CreatePlacementOrPackageService.cleanAndConvertString(field)];
                updatedFieldValue = updatedFieldValue?.toLowerCase();
                if (updatedFieldValue) {
                    fields.forEach((tfield) => {
                        if (tfield.name === field) {
                            if (tfield?.field_type === 1) {
                                tfield.fielditems.forEach((fieldOption) => {
                                    if (CreatePlacementOrPackageService.cleanAndConvertString(fieldOption.name) === updatedFieldValue) {
                                        DefaultData['Parameter Code ' + field] = fieldOption.code;
                                    }
                                })
                            } else {
                                DefaultData['Parameter Code ' + field] = updatePlacementData[CreatePlacementOrPackageService.cleanAndConvertString(field)]
                            }
                        }
                    })
                }
            })
        }
    },
}